/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
/*[object Object]*/
import { createEntityAdapter } from '@reduxjs/toolkit';

import { CatalogItem } from '@ibm-watson/shared/ts/catalog';

// Entity Adapter
// use id/entity for catalogIntegrationsInstances
// note leave sortComparer undefined, fine that it leaves array unsorted
export const catalogAdapter = createEntityAdapter<CatalogItem>({
  selectId: catalog => catalog?.catalog_item_id
});
